import { type Fields } from '../../types';
import { FieldTypes } from '../../types/fieldTypes';
import { intensityOptions as options } from './options';

// https://www.gdsuite.it/laravel/v1/visita/data?pk_id_pt=37392&pk_id_vt=26030&group=100
export const step1: Fields = [
  {
    code: 101,
    name: 'Cefalea',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 102,
    name: 'Prurito',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 103,
    name: 'Acidità di stomaco',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 104,
    name: 'Gonfiori addominali/meteorismo',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 105,
    name: 'Crampi a riposo',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 106,
    name: 'Ritenzione idrica',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
  {
    code: 107,
    name: 'Stipsi',
    type: FieldTypes.radio,
    options,
    group: 100,
  },
];
